import { render, staticRenderFns } from "./PortalHome.vue?vue&type=template&id=7036b2be&scoped=true&"
import script from "./PortalHome.vue?vue&type=script&lang=js&"
export * from "./PortalHome.vue?vue&type=script&lang=js&"
import style0 from "./PortalHome.vue?vue&type=style&index=0&id=7036b2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036b2be",
  null
  
)

export default component.exports